import "../phaser.min.js";
import Common from "../Includes/Common.js";
import Question from "../Scenes/Question.js";
import Car from "../Scenes/Car.js";
import TriviaInfo from "../Scenes/TriviaInfo.js";
import GameLost from "./GameLost";
import GameOver from "./GameOver";

class Quiz extends Phaser.Scene {
    constructor() {
        super('Quiz');
        this.common = new Common();
        this.questions = [];
    }

    init(data) {
        this.errorThreshold = 5;
        this.gameLost = false;
        this.player = data.player;
        this.progress = 0;
        this.scrollSpeed = 100;
        this.streak = 0;
        this.streakPoints = [4, 8, 12, 16, 20, 24];
        this.wrongAnswers = 0;
        this.bgManager = this.scene.get('BackgroundManager');
        this.uiScene = this.scene.get('Ui')

        //LEVEL CHANGES
        // the number key indicates which question will trigger a scene change
        this.progressions = {
            8: ()=>{
                this.bgManager.transitionTo('FarmBackground', this.scrollSpeed);
            },
            16: () => {
                this.bgManager.transitionTo('MountainBackground', this.scrollSpeed);
            }
        }

        //SOUND
        if(this.uiScene.soundOn){
            this.sound.mute = false;
        }else{
            this.sound.mute = true;
        }

        //QUESTIONS FETCH and SHUFFLE
        var request = new XMLHttpRequest();
        request.open('GET', this.common.assetsPath + 'json/questions.json', false); // false makes it synchronous
        request.send(null);
        if (request.status === 200) {
            var reqdata = JSON.parse(request.responseText);
            this.allQuestions = reqdata.questions;
            //this.checkCharacterCounts();
            this.questions = structuredClone(this.allQuestions);
            //QUESTIONS
            for (let i = this.questions.length - 1; i > 0; i--) {
                // Generate a random index between 0 and i
                const j = Math.floor(Math.random() * (i + 1));
                // Swap elements at i and j using destructuring
                [this.questions[i], this.questions[j]] = [this.questions[j], this.questions[i]];
            }
            this.questions.length = Math.min(this.questions.length, 24);
        }else{
            console.log('Error fetching questions.json');
        }
    }

    checkCharacterCounts() {
        for(let i = 0; i < this.allQuestions.length; i++){
            console.log('----------------------')
            console.log(i + ": " + this.allQuestions[i].question);
            console.log(this.allQuestions[i].question.length);
            if(this.allQuestions[i].answers.length > 340){
                console.log('TOO LONG');
            }
            for(let j = 0; j < this.allQuestions[i].answers.length; j++){
                console.log(this.allQuestions[i].answers[j].length);
                if(this.allQuestions[i].answers[j].length > 100){
                    console.log('TOO LONG');
                }
            }
            console.log('----------------------')
        }
    }

    preload() {

    }

    create() {
        if(!this.scene.get('GameLost')) {
            this.scene.add('GameLost', GameLost)
        }


        //SOUND
        this.blip = this.sound.add('blip', {volume: this.common.blipVolume})
        this.failSFX = this.sound.add('fail', {volume: this.common.blipVolume})
        this.successSFX = this.sound.add('success', {volume: this.common.blipVolume})
        this.music = this.sound.add('bg-music', {volume: this.common.bgMusicVolume, loop: true})
        this.music.play()
        this.uiScene.events.on('soundSettingChange', (data) => {
            if(data.soundOn){
                this.sound.mute = false;
            }else{
                this.sound.mute = true;
            }
        })

        this.bgManager.quizHandler();

        //CAR
        this.scene.add('Car', Car)
        this.scene.launch('Car', {
            x: this.scale.width / 12 * 2,
            carKey: this.player.car.key,
            driving: true,
        });
        this.scene.moveBelow('Question', 'Car');
        const car = this.scene.get('Car');
        this.bgManager.carHandler();

        this.scene.add('Question', Question)
        //QUESTION
        this.scene.launch('Question', {
            id: this.progress,
            key: this.progress,
            question: this.questions[this.progress].question,
            answers: this.questions[this.progress].answers,
            correctAnswer: this.questions[this.progress].correctAnswer,
            callback: null,
            quiz: this
        })
        const question = this.scene.get('Question');
        question.events.on('question-answered', (data) => {
            this.player.playTime += data.elapsedTime;
            this.questions[data.key].marked = data.isRightAnswer;
            this.questions[data.key].elapsedTime = data.elapsedTime;
            this.questions[data.key].answered = data.answered;
            this.progress++;

            if(data.isRightAnswer) {
                const bonusPoints = Math.max(0, 1000 - ((Math.floor(data.elapsedTime / 1000) - 1) * 100));
                this.player.score += 1000 + bonusPoints;
                this.events.emit('update-trivia-info', {
                    score: this.player.score,
                    bonus: bonusPoints,
                });

                this.increaseStreak();
                this.successSFX.play();
                if (!this.progressions.hasOwnProperty(this.progress)) {
                    this.bgManager.events.emit('fire-background-event');
                }
            }else{
                this.handleWrongAnswer();
                if(this.gameLost){
                    this.music.pause();
                    this.gameLostScreen();
                    return;
                }
            }

            if (this.progressions.hasOwnProperty(this.progress)) {
                this.progressions[this.progress]()
            }
        }, this)
        question.events.on('ready-for-next-question', () => {
            // From your active scene, target the scene you want to remove
            this.events.emit('update-trivia-info', {
                currentQuestionIndex: this.progress + 1,
            });

            if (this.progress < this.questions.length) {
                this.events.emit('resetQuestion', {
                    id: this.progress,
                    key: this.progress,
                    question: this.questions[this.progress].question,
                    answers: this.questions[this.progress].answers,
                    correctAnswer: this.questions[this.progress].correctAnswer,
                    callback: null,
                })
            } else {
                //WIN
                if(!this.scene.get('GameOver')) {
                    this.music.stop();
                    this.scene.add('GameOver', GameOver)
                }
                this.scene.start('GameOver', {player: this.player, questions: this.questions})
                this.scene.bringToTop('GameOver')
            }
        }, this)


        //TRIVIA INFO
        this.scene.add('TriviaInfo', TriviaInfo)
        this.scene.launch('TriviaInfo', {
            totalQuestions: this.questions.length,
            currentQuestionIndex: this.progress + 1,
            score: this.player.score
        })
        this.scene.bringToTop('TriviaInfo')
        this.scene.bringToTop('Ui')
        this.triviaInfo = this.scene.get('TriviaInfo')

        //STREAK
        this.events.on('streak-ended', () => {
            this.scrollSpeed = 50;
            this.events.emit('scroll-speed-changed', {scrollSpeed: this.scrollSpeed})
            this.streak = 0;
        }, this)

        this.events.on('streak-triggered', () => {
            this.blip.play({detune: -2000, seek: 0.12, volume: this.common.blipVolume});
            let tween = this.tweens.addCounter({
                from: this.scrollSpeed,
                to: this.scrollSpeed + 50,
                duration: 1000, // 1 second
                ease: 'Linear',
                onUpdate: (tween) => {
                    this.scrollSpeed = Math.floor(tween.getValue());
                    this.events.emit('scroll-speed-changed', {scrollSpeed: this.scrollSpeed})
                },
                onComplete: () => {
                    this.events.emit('scroll-speed-changed', {scrollSpeed: this.scrollSpeed})
                }
            });

        }, this)

        //PLAYER
        this.player.registerEvents(this);

        // let tween = this.tweens.addCounter({
        //     from: 100,
        //     to: 50,
        //     duration: 1000, // 1 second
        //     ease: 'Linear',
        //     onUpdate: (tween) => {
        //         this.scrollSpeed = Math.floor(tween.getValue());
        //         this.events.emit('scroll-speed-changed', {scrollSpeed: this.scrollSpeed})
        //     },
        //     onComplete: () => {
        //
        //     }
        // });


    }


    handleWrongAnswer = ()=> {
        this.events.emit('streak-ended', {
            errorThreshold: this.errorThreshold,
            wrongAnswers: this.wrongAnswers,
        })
        this.failSFX.play();
        this.wrongAnswers++;
        if(this.wrongAnswers >= this.errorThreshold){
            this.gameLost = true;
        }
    }

    increaseStreak = ()=> {
        this.streak++;
        if (this.streakPoints.includes(this.streak)) {
            this.events.emit('streak-triggered')
        }
    }

    gameLostScreen() {
        this.scene.pause('Quiz');
        this.scene.pause('TriviaInfo');
        this.scene.pause('Question');
        this.scene.launch('GameLost', {player: this.player})
        this.scene.bringToTop('GameLost')
    }

    reset() {
        this.progress = 0;
        // controls background scroll speed
        this.scrollSpeed = 100;
        // current number of correct answers in a row
        this.streak = 0;
        this.wrongAnswers = 0;
        this.gameLost = false;
        this.player.score = 0;

        this.events.emit('update-trivia-info', {
            currentQuestionIndex: this.progress + 1,
            score: this.player.score,
            noAnims: true,
        });
        this.events.emit('stop-timer');
        this.events.emit('scroll-speed-changed', {scrollSpeed: this.scrollSpeed})
        this.events.emit('reset')

        this.questions = [];
        this.questions = structuredClone(this.allQuestions);
        //QUESTIONS
        for (let i = this.questions.length - 1; i > 0; i--) {
            // Generate a random index between 0 and i
            const j = Math.floor(Math.random() * (i + 1));
            // Swap elements at i and j using destructuring
            [this.questions[i], this.questions[j]] = [this.questions[j], this.questions[i]];
        }
        this.questions.length = Math.min(this.questions.length, 24);

        this.events.emit('resetQuestion', {
            id: this.progress,
            key: this.progress,
            question: this.questions[this.progress].question,
            answers: this.questions[this.progress].answers,
            correctAnswer: this.questions[this.progress].correctAnswer,
            callback: null,
        })
        this.events.emit('update-trivia-info', {
            currentQuestionIndex: this.progress + 1,
            score: this.player.score,
            noAnims: true,
        });
        this.events.emit('start-timer');
    }
}

export default Quiz;